import { useState } from "react";
import { IAnnouncement } from "@/common/api/services/types";
import { InfoBar } from "./InfoBar";
import { metricsBus } from "@/common/buses";
import { useUserStore } from "@/common/store/userStore";
import { setLastSeenAnnouncement } from "@/common/utils/storage";
import { apiAnnouncements } from "@/common/services";
import { useAnnouncement } from "components/alerts/InfoBar/hooks/useAnnouncement";

declare global {
  interface Window {
    announcements: {
      global?: {
        anonymous?: IAnnouncement[];
        verified?: IAnnouncement[];
        unverified?: IAnnouncement[];
      };
    };
  }
}

export const Announcement = () => {
  const username = useUserStore((state) => state.currentUser?.username);
  const [showNotify, setShowNotify] = useState<boolean>(true);
  const { announcement } = useAnnouncement();

  const sendDeleteAnnouncement = async (id: string) => {
    try {
      await apiAnnouncements.deleteAnnouncement(id);
    } catch (err) {
      console.error(err);
    }
  };

  const onLinkAction = async (id: string) => {
    metricsBus.emit("infoBarClicked", { announcement: id });
    setLastSeenAnnouncement(id);

    if (username) {
      await sendDeleteAnnouncement(id);
    }

    setShowNotify(false);
  };

  const onCloseInfoBar = (id: string) => {
    metricsBus.emit("infoBarClosed", { announcement: id });
    setShowNotify(false);
    setLastSeenAnnouncement(id);

    if (username) {
      sendDeleteAnnouncement(id);
    }
  };

  if (!announcement) {
    return null;
  }

  return (
    <InfoBar
      showNotify={showNotify}
      onLinkAction={onLinkAction}
      onCloseInfoBar={onCloseInfoBar}
      notification={announcement}
    />
  );
};

export default Announcement;
